module.exports = __webpack_public_path__ + "resources/img/logo_toast_gov_color.170f57800e13b95705286c3a30a807a0.png";